//Componentes generales
import React, { useState, useEffect } from "react";
import AutocompleteV2 from "../AutoCompleteV2/AutoCompleteV2";
import SelectList from "../SelectList/SelectList";

// API
import { getAbmDistribucion, getAbmSubcuentaDistribucion, getAbmSubcuentasDistribucionByCodDimAndCodDis } from "../../api/abmDistribution";

// Config
import { ENTORNO } from "../../config/config";

// Estilos
import "./NewProductItm.css";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

/*
    Componente encargado de toda la logica del ingreso de un nuevo item en carga de requerimiento.
        Donde data es el item en el cual esta posicionado.
              index es la posición del item.
              productList es la lista de productos disponibles.
              agregaItem es la función que agrega el nuevo item.
              modificaItm es la función que modifica el item.
              borraItem es la función que borra el item.
*/
function NewProductItm({
  data,
  index,
  edicion,
  productsList,
  agregaItem,
  modificaItm,
  borraItem,
  tiposCosto,
  centrosCosto,
}) {
  //state de item.
  const [selected, setSelected] = useState(data);
  const [quantityInput, setQuantityInput] = useState(data.quantity === 0 ? 1 : data.quantity);
  const [priceInput, setPriceInput] = useState(data.price ?? "");

  // state modal centro de costo
  const [modalCentroCosto, setModalCentroCosto] = useState(false);
  const [distribuciones, setDistribuciones] = useState([]);
  const [subcuentasLibres, setSubcuentasLibres] = useState([]);
  const [selectedDistribucion, setSelectedDistribucion] = useState(
    data.centroCostoDistribucion?.tipo === "distribucion"
      ? data.centroCostoDistribucion?.distribucion || null
      : null
  );
  const [subcuentas, setSubcuentas] = useState(
    data.centroCostoDistribucion?.tipo === "distribucion"
      ? data.centroCostoDistribucion?.subcuentas || []
      : []
  );
  const [subcuentaCantidades, setSubcuentaCantidades] = useState(() => {
    const cantidades = {};
    if (data.centroCostoDistribucion?.tipo === "distribucion") {
      (data.centroCostoDistribucion?.subcuentas || []).forEach((s) => {
        cantidades[s.subCue] = s.cantidad ?? "";
      });
    }
    return cantidades;
  });
  const [filasSubcuentas, setFilasSubcuentas] = useState(() => {
    if (data.centroCostoDistribucion?.tipo === "manual" && data.centroCostoDistribucion?.filasSubcuentas?.length > 0) {
      return data.centroCostoDistribucion.filasSubcuentas;
    }
    return [{ id: "init-0", subCue: null, cantidad: "" }];
  });
  const [errorSuma, setErrorSuma] = useState(false);
  const [errorCantidadCero, setErrorCantidadCero] = useState(false);
  const [snapshot, setSnapshot] = useState(null);

  /* 
        Manejador encargado de la logica del autocompletado ante una modificación.
            Donde value es el valor ingresado por el usuario.
    */
  const handlerChangeAutoComplete = (value) => {
    const indice = index;
    const productoSeleccionado = productsList.find(
      (p) =>
        `${p.tipPro}${p.artCod}`.replace(/\s+/g, "") ===
        value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (productoSeleccionado !== undefined) {
      const s = {
        ...data,
        tipPro: productoSeleccionado.tipPro,
        artCod: productoSeleccionado.artCod,
        codRed: productoSeleccionado.codRed,
        descrp: productoSeleccionado.descrp,
        price: productoSeleccionado.price,
        uniMed: productoSeleccionado.uniMed,
        cuenPv: productoSeleccionado.cuenPv || "",
      };

      if (data.artCod !== "") modificaItm(s, indice);
      else agregaItem(s);
      setSelected(s);
    }
    if (productoSeleccionado == undefined && value == "") {
      borraItem(data, indice);
      setSelected(data);
    }
  };

  /* 
        Manejador encargado de la modificación de la cantidad del item.
            Donde cantid es el valor ingresado por el usuario.
    */
  const handleChangeQuantity = (cantid) => {
    setQuantityInput(cantid);
  };

  const handleFocusQuantity = () => {
    if (String(quantityInput) === "1") {
      setQuantityInput("");
    }
  };

  const handleBlurQuantity = () => {
    const parsed = parseFloat(quantityInput);
    if (!quantityInput || isNaN(parsed) || parsed <= 0) {
      setQuantityInput(1);
      const s = { ...selected, quantity: 1 };
      setSelected(s);
      modificaItm(s, index);
    } else {
      const s = { ...selected, quantity: parsed };
      setSelected(s);
      modificaItm(s, index);
    }
  };

  /* 
        Manejador encargado de la modificación del texto del item.
            Donde texto es el valor ingresado por el usuario.
    */
  const handleChangeTextAdic = (texto) => {
    const indice = index;
    const s = { ...selected, textAdic: texto };
    setSelected(s);
    modificaItm(s, indice);
  };

  const handleChangePrice = (value) => {
    setPriceInput(value);
  };

  const handleBlurPrice = () => {
    const parsed = parseFloat(priceInput);
    const newPrice = isNaN(parsed) || parsed < 0 ? 0 : parsed;
    setPriceInput(newPrice);
    const s = { ...selected, price: newPrice };
    setSelected(s);
    modificaItm(s, index);
  };

  const handleChangeTipoCosto = async (value) => {
    const [subCueVal, codDisVal] = (value.value || "").split("__");
    const tipoCostoSeleccionado = tiposCosto.find(
      (tC) =>
        tC.subCue.replace(/\s+/g, "") === (subCueVal || "").replace(/\s+/g, "") &&
        (tC.codDis || "").replace(/\s+/g, "") === (codDisVal || "").replace(/\s+/g, "")
    );

    if (tipoCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        tipoCosto: {
          abmCodDim: tipoCostoSeleccionado.codDim,
          abmCodDimDescrp: tipoCostoSeleccionado.codDimDescrp,
          abmCodDis: tipoCostoSeleccionado.codDis,
          abmCodDisDescrp: tipoCostoSeleccionado.codDisDescrp,
          abmSubCue: tipoCostoSeleccionado.subCue,
          abmSubCueDescrp: tipoCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  };

/*   const handleChangeCentroCosto = async (value) => {
    const centroCostoSeleccionado = centrosCosto.find(
      (cC) =>
        `${cC.subCue}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (centroCostoSeleccionado !== undefined) {
      const indice = index;
      const s = {
        ...selected,
        centroCosto: {
          abmCodDim: centroCostoSeleccionado.codDim,
          abmCodDimDescrp: centroCostoSeleccionado.codDimDescrp,
          abmSubCue: centroCostoSeleccionado.subCue,
          abmSubCueDescrp: centroCostoSeleccionado.subCueDescrp,
        },
      };
      setSelected(s);
      modificaItm(s, indice);
    }
  }; */

  const codDimCentroCosto = ENTORNO && ENTORNO.toLowerCase().includes("casport") ? "CTRCTO" : "CCO";

  const abrirModalCentroCosto = async () => {
    setSnapshot({ selectedDistribucion, subcuentas, subcuentaCantidades, filasSubcuentas });
    setModalCentroCosto(true);
    if (distribuciones.length === 0) {
      try {
        const resp = await getAbmDistribucion();
        const filtradas = (resp.data.data || []).filter((d) => d.codDim?.replace(/\s+/g, "") === codDimCentroCosto);
        setDistribuciones(filtradas);
      } catch (e) { console.error(e); }
    }
    if (subcuentasLibres.length === 0) {
      try {
        const resp = await getAbmSubcuentaDistribucion();
        const filtradas = (resp.data.data || []).filter((s) => s.dimSub?.replace(/\s+/g, "") === codDimCentroCosto);
        setSubcuentasLibres(filtradas);
      } catch (e) { console.error(e); }
    }
  };

  const handleSeleccionarDistribucion = async (value) => {
    if (!value) {
      setSelectedDistribucion(null);
      setSubcuentas([]);
      setSubcuentaCantidades({});
      setFilasSubcuentas([{ id: Date.now().toString(), subCue: null, cantidad: "" }]);
      setErrorSuma(false);
      return;
    }
    const dist = distribuciones.find((d) => d.codDis?.replace(/\s+/g, "") === value.value?.replace(/\s+/g, ""));
    setSelectedDistribucion(dist || null);
    setFilasSubcuentas([{ id: Date.now().toString(), subCue: null, cantidad: "" }]);
    setSubcuentas([]);
    setSubcuentaCantidades({});
    setErrorSuma(false);
    if (dist) {
      try {
        const resp = await getAbmSubcuentasDistribucionByCodDimAndCodDis(dist.codDim.trim(), dist.codDis.trim());
        setSubcuentas(resp.data.data || []);
        const cantidades = {};
        (resp.data.data || []).forEach((s) => { cantidades[s.subCue] = ""; });
        setSubcuentaCantidades(cantidades);
      } catch (e) { console.error(e); }
    }
  };

  const handleCantidadSubcuenta = (subCue, valor) => {
    setSubcuentaCantidades((prev) => ({ ...prev, [subCue]: valor }));
    setErrorSuma(false);
  };

  const handleSeleccionarSubcuenta = (id, value) => {
    setErrorSuma(false);
    setFilasSubcuentas((prev) => {
      const idx = prev.findIndex((f) => f.id === id);
      if (!value) {
        if (prev.length === 1) return [{ id: Date.now().toString(), subCue: null, cantidad: "" }];
        return prev.filter((f) => f.id !== id);
      }
      const subObj = subcuentasLibres.find((s) => s.subCue?.trim() === value.value?.trim());
      const updated = prev.map((f) => f.id === id ? { ...f, subCue: value.value?.trim() || null, subCueDescrp: subObj?.subCueDescrp || '' } : f);
      if (idx === prev.length - 1) {
        updated.push({ id: Date.now().toString(), subCue: null, cantidad: "" });
      }
      return updated;
    });
  };

  const handleCantidadFila = (id, valor) => {
    setFilasSubcuentas((prev) => prev.map((f) => f.id === id ? { ...f, cantidad: valor } : f));
    setErrorSuma(false);
    setErrorCantidadCero(false);
  };

  const cantRequerida = parseFloat(quantityInput) || 0;
  const sumaSubcuentas = selectedDistribucion
    ? subcuentas.reduce((acc, s) => acc + (s.porcen != null ? (cantRequerida * (parseFloat(s.porcen) || 0)) / 100 : (parseFloat(s.cantidad) || 0)), 0)
    : filasSubcuentas.filter((f) => f.subCue).reduce((acc, f) => acc + (parseFloat(f.cantidad) || 0), 0);
  const haySubcuentas = selectedDistribucion ? subcuentas.length > 0 : filasSubcuentas.some((f) => f.subCue);
  const sumaEsValida = !haySubcuentas || !!selectedDistribucion || Math.abs(sumaSubcuentas - cantRequerida) < 0.001;

  const cerrarModalCentroCosto = () => {
    if (snapshot) {
      setSelectedDistribucion(snapshot.selectedDistribucion);
      setSubcuentas(snapshot.subcuentas);
      setSubcuentaCantidades(snapshot.subcuentaCantidades);
      setFilasSubcuentas(snapshot.filasSubcuentas);
    }
    setErrorSuma(false);
    setErrorCantidadCero(false);
    setModalCentroCosto(false);
    setSnapshot(null);
  };

  const handleAceptarCentroCosto = () => {
    if (!selectedDistribucion) {
      const filasConSubcuenta = filasSubcuentas.filter((f) => f.subCue);
      const hayCantidadCero = filasConSubcuenta.some((f) => !(parseFloat(f.cantidad) > 0));
      if (hayCantidadCero) {
        setErrorCantidadCero(true);
        setErrorSuma(false);
        return;
      }
    }
    setErrorCantidadCero(false);
    if (!sumaEsValida) {
      setErrorSuma(true);
      return;
    }
    const filasValidas = filasSubcuentas.filter((f) => f.subCue);
    const s = {
      ...selected,
      centroCostoDistribucion: selectedDistribucion
        ? {
            tipo: "distribucion",
            distribucion: selectedDistribucion,
            subcuentas: (() => {
              const r2 = (v) => Math.round(v * 100) / 100;
              const calculadas = subcuentas.map((sub) => ({
                subCue: sub.subCue,
                subCueDescrp: sub.subCueDescrp,
                cantidad: r2(sub.porcen != null ? (cantRequerida * (parseFloat(sub.porcen) || 0)) / 100 : (parseFloat(sub.cantidad) || 0)),
                porcen: sub.porcen,
              }));
              const sumaCalculada = calculadas.reduce((acc, s) => acc + s.cantidad, 0);
              const diferencia = r2(cantRequerida - sumaCalculada);
              if (Math.abs(diferencia) > 0.0001 && calculadas.length > 0) {
                calculadas[0] = { ...calculadas[0], cantidad: r2(calculadas[0].cantidad + diferencia) };
              }
              return calculadas;
            })(),
            filasSubcuentas: [],
          }
        : {
            tipo: "manual",
            distribucion: null,
            subcuentas: filasValidas.map((f) => ({ subCue: f.subCue, subCueDescrp: f.subCueDescrp, cantidad: f.cantidad })),
            filasSubcuentas,
          },
    };
    setSelected(s);
    modificaItm(s, index);
    setModalCentroCosto(false);
    setSnapshot(null);
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      padding: "10px 14px",
      gap: "6px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
      border: "1px solid #e8e8e8",
      marginBottom: "8px",
    }}>

      {/* Fila 1: ícono + producto + cantidad + descripción adicional */}
      <div className="container-row-form-item" style={{ margin: 0, padding: 0 }}>
        <div>
          <FontAwesomeIcon
            icon={faBackspace}
            color="red"
            style={{
              width: "35px",
              height: "35px",
              cursor: "pointer",
            }}
            onClick={borraItem}
          />
        </div>

        <div className="input-autocomplete-form-item" style={{ flex: 2 }}>
          <AutocompleteV2
            placeholder={"Ingrese un producto"}
            height={"40px"}
            value={
              selected.tipPro !== ""
                ? `${selected.tipPro}${selected.artCod} ~ ${selected.descrp}`
                : ""
            }
            setValue={handlerChangeAutoComplete}
            dataSuggestions={productsList.map((p) => {
              return {
                code: `${p.tipPro}${p.artCod}`,
                descrp: `${p.descrp} (${p.codRed})`,
              };
            })}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px", marginRight: "10px" }}>
          <input
            value={quantityInput}
            type="number"
            placeholder="Cant."
            onChange={(datat) => handleChangeQuantity(datat.target.value)}
            onFocus={handleFocusQuantity}
            onBlur={handleBlurQuantity}
            style={{
              height: "40px",
              width: `${Math.max(4, String(quantityInput).length) * 14 + 16}px`,
              textAlign: "center",
              fontSize: "1rem",
              borderRadius: 5,
              border: "none",
              boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
              textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
            }}
          />
          {selected.uniMed && (
            <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#4a4a4a", whiteSpace: "nowrap" }}>
              {selected.uniMed}
            </span>
          )}
        </div>

        <input
          value={selected.textAdic}
          placeholder="Descripción adicional"
          onChange={(datat) => handleChangeTextAdic(datat.target.value)}
          style={{
            flex: 1,
            fontSize: "1rem",
            height: "40px",
            borderRadius: 5,
            border: "none",
            boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
            textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.4)",
          }}
        />
      </div>

      {/* Fila 2: precio (edicion) + tipo de costo + centro de costo */}
      {(edicion === "Edicion" && selected.artCod !== "" || (selected.artCod !== "" && (tiposCosto || centrosCosto))) && (
        <div style={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          paddingTop: "6px",
          borderTop: "1px solid #ebebeb",
          justifyContent: "center",
          alignItems: "center",
        }}>
          {edicion === "Edicion" && selected.artCod !== "" && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "1.2rem", fontWeight: 600, color: "#4a4a4a", textShadow: "0.5px 0.5px 0.5px rgb(0, 0, 0)" }}>USD</span>
                <input
                  type="number"
                  value={priceInput}
                  onChange={(e) => handleChangePrice(e.target.value)}
                  onBlur={handleBlurPrice}
                  className="price-input"
                  style={{
                    height: "40px",
                    width: "150px",
                    fontWeight: "600",
                    fontSize: "1.2rem",
                    textAlign: "left",
                    fontSize: "1.1rem",
                    borderRadius: 5,
                    border: "1px solid #ccc",
                    boxShadow: "rgba(148, 142, 142, 0.59) 4px 5px 5px 0px",
                    padding: "0 8px",
                    boxSizing: "border-box",
                  }}
                />
              </div>
            </div>
          )}
          {tiposCosto && (
            <div className="selectSubcuenta" style={{ width: "clamp(200px, 30%, 420px)" }}>
              <SelectList
                colorInputText={selected.tipoCosto?.abmSubCue ? "black" : "#7c7b7b"}
                textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
                backgroundColor={"white"}
                menuPlacement={"bottom"}
                height={"40px"}
                border={true}
                options={tiposCosto.map((cC) => {
                  const dis = cC.codDis?.trim() ? ` (${cC.codDis.trim()}${cC.codDisDescrp?.trim() ? ` - ${cC.codDisDescrp.trim()}` : ""})` : "";
                  return {
                    value: `${cC.subCue}__${cC.codDis || ""}`,
                    label: `${cC.subCue} - ${cC.subCueDescrp}${dis}`,
                  };
                })}
                handleChange={handleChangeTipoCosto}
                property={"Tipo de Costo"}
                valueAux={{
                  label: selected.tipoCosto?.abmSubCue
                    ? `${selected.tipoCosto.abmSubCue} - ${selected.tipoCosto.abmSubCueDescrp}${selected.tipoCosto.abmCodDis?.trim() ? ` (${selected.tipoCosto.abmCodDis.trim()}${selected.tipoCosto.abmCodDisDescrp?.trim() ? ` - ${selected.tipoCosto.abmCodDisDescrp.trim()}` : ""})` : ""}`
                    : "Seleccione tipo de costo...",
                  value: selected.tipoCosto?.abmSubCue ? `${selected.tipoCosto.abmSubCue}__${selected.tipoCosto.abmCodDis || ""}` : "",
                }}
                emptyInputs={[]}
                styles={{
                  additionalStyleDivSelectList: { alignItems: "left" },
                  fontStyleTitle: { fontSize: "1rem", color: "#7c7b7b", marginLeft: "9px" },
                }}
                fontWeight="700"
                fontWeightSingleValue="500"
              />
            </div>
          )}
          {centrosCosto && (
            <button
              className="btn-centro-costo"
              onClick={abrirModalCentroCosto}
              type="button"
            >
              Centro de costo
              <FontAwesomeIcon icon={faPlus} className="btn-centro-costo-icon" />
            </button>
          )}

          {/* Modal Centro de Costo */}
          {modalCentroCosto && (
            <div className="modal-centro-costo-overlay" onClick={(e) => { if (e.target === e.currentTarget) cerrarModalCentroCosto(); }}>
              <div className="modal-centro-costo-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-centro-costo-header">
                  <span className="modal-centro-costo-title">Centro de costo</span>
                  <FontAwesomeIcon
                    icon={faTimes}
                    className="modal-centro-costo-close"
                    onClick={cerrarModalCentroCosto}
                  />
                </div>

                <div className="modal-centro-costo-body">
                  <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
                  <span style={{ fontSize: "1rem", fontWeight: 700, color: "#1d1c1c", marginLeft: "9px", textDecoration: "underline" }}>Código de distribución</span>
                  <div style={{ display: "flex", alignItems: "center", width: "100%", gap: "6px" }}>
                    <div className="selectSubcuenta" style={{ flex: 1 }}>
                      <SelectList
                        color={"black"}
                        colorInputText={selectedDistribucion ? "black" : "#7c7b7b"}
                        textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
                        backgroundColor={"white"}
                        menuPlacement={"bottom"}
                        height={"40px"}
                        border={true}
                        options={distribuciones.map((d) => ({
                          value: d.codDis?.replace(/\s+/g, ""),
                          label: `${d.codDis?.trim()} - ${d.codDisDescrp?.trim()}`,
                        }))}
                        handleChange={handleSeleccionarDistribucion}
                        isClearable={false}
                        property={"Distribución"}
                        valueAux={{
                          label: selectedDistribucion
                            ? `${selectedDistribucion.codDis?.trim()} - ${selectedDistribucion.codDisDescrp?.trim()}`
                            : "Seleccione distribución...",
                          value: selectedDistribucion?.codDis || "",
                        }}
                        emptyInputs={[]}
                        styles={{
                          additionalStyleDivSelectList: { alignItems: "left" },
                          fontStyleTitle: { fontSize: "1rem", color: "#7c7b7b", marginLeft: "9px" },
                        }}
                        fontWeight="700"
                        fontWeightSingleValue="500"
                      />
                    </div>
                    {selectedDistribucion && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleSeleccionarDistribucion(null); }}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#e53e3e", fontSize: "1.1rem", padding: "0 4px", lineHeight: 1 }}
                        title="Quitar distribución"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                  </div>

                  <div className="modal-subcuentas-list">
                    <div className="modal-subcuenta-row modal-subcuenta-header">
                      <span className="modal-subcuenta-label">Código de subcuenta</span>
                      <span className="modal-subcuenta-header-qty">Cantidad</span>
                    </div>

                    {/* Modo distribución: subcuentas bloqueadas con cantidad calculada por porcentaje */}
                    {selectedDistribucion && (() => {
                      const r2 = (v) => Math.round(v * 100) / 100;
                      const montos = subcuentas.map(s => r2(s.porcen != null ? (cantRequerida * (parseFloat(s.porcen) || 0)) / 100 : (parseFloat(s.cantidad) || 0)));
                      const suma = montos.reduce((acc, v) => acc + v, 0);
                      const dif = r2(cantRequerida - suma);
                      if (Math.abs(dif) > 0.0001 && montos.length > 0) montos[0] = r2(montos[0] + dif);
                      return subcuentas.map((s, idx) => (
                        <div key={s.subCue} className="modal-subcuenta-row">
                          <span className="modal-subcuenta-label">{s.subCue?.trim()}{s.subCueDescrp?.trim() ? ` - ${s.subCueDescrp?.trim()}` : ""}</span>
                          <input
                            type="number"
                            className="modal-subcuenta-input modal-subcuenta-input-readonly"
                            value={montos[idx]}
                            readOnly
                            tabIndex={-1}
                          />
                        </div>
                      ));
                    })()}

                    {/* Modo manual: selects dinámicos */}
                    {!selectedDistribucion && filasSubcuentas.map((fila) => {
                      const seleccionadas = filasSubcuentas.filter((f) => f.id !== fila.id && f.subCue).map((f) => f.subCue);
                      const opcionesDisponibles = subcuentasLibres
                        .filter((s) => !seleccionadas.includes(s.subCue?.trim()))
                        .map((s) => ({
                          value: s.subCue?.trim(),
                          label: s.subCueDescrp?.trim() ? `${s.subCue?.trim()} - ${s.subCueDescrp?.trim()}` : s.subCue?.trim(),
                        }));
                      const subSeleccionada = fila.subCue ? subcuentasLibres.find((s) => s.subCue?.trim() === fila.subCue) : null;
                      return (
                        <div key={fila.id} className="modal-subcuenta-row">
                          <div style={{ flex: 1 }}>
                            <SelectList
                              color={"black"}
                              colorInputText={fila.subCue ? "black" : "#7c7b7b"}
                              textShadow={"0.5px 0.5px 0.5px rgba(0,0,0,0.4)"}
                              backgroundColor={"white"}
                              menuPlacement={"auto"}
                              height={"36px"}
                              border={true}
                              options={opcionesDisponibles}
                              handleChange={(val) => handleSeleccionarSubcuenta(fila.id, val)}
                              isClearable={true}
                              property={"subcuenta"}
                              valueAux={fila.subCue
                                ? {
                                    value: fila.subCue,
                                    label: subSeleccionada?.subCueDescrp?.trim()
                                      ? `${fila.subCue} - ${subSeleccionada.subCueDescrp?.trim()}`
                                      : fila.subCue,
                                  }
                                : { value: "", label: "Seleccione subcuenta..." }
                              }
                              emptyInputs={[]}
                              fontWeight="700"
                              fontWeightSingleValue="500"
                            />
                          </div>
                          <input
                            type="number"
                            className="modal-subcuenta-input"
                            placeholder="0"
                            step="0.01"
                            value={fila.cantidad}
                            onChange={(e) => {
                              const v = e.target.value;
                              if (v === "" || /^\d*\.?\d{0,2}$/.test(v)) handleCantidadFila(fila.id, v);
                            }}
                            disabled={!fila.subCue}
                          />
                        </div>
                      );
                    })}

                    {errorCantidadCero && (
                      <div className="modal-subcuenta-suma suma-error">
                        <span className="suma-aviso">Debe asignar cantidad a todas las subcuentas</span>
                      </div>
                    )}
                    {errorSuma && (
                      <div className="modal-subcuenta-suma suma-error">
                        <span className="suma-aviso">La suma de las cantidades debe ser igual a la cantidad del producto</span>
                      </div>
                    )}
                  </div>
                  <div className="modal-centro-costo-footer">
                    <button
                      type="button"
                      className="modal-btn modal-btn-cancelar"
                      onClick={cerrarModalCentroCosto}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className="modal-btn modal-btn-aceptar"
                      onClick={handleAceptarCentroCosto}
                      disabled={false}
                    >
                      Aceptar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

    </div>
  );
}

export default NewProductItm;